<template>
  <div class="header-wrapper">
    <div class="container-form">
      <div class="content-form change-password">
        <img
          src="@/assets/images/logo-page.png"
          alt="logo top"
          class="logo-top"
        />

        <el-form
          :model="changePasswordForm"
          :rules="validator"
          ref="changePasswordForm"
          label-width="150px"
          class="login-form"
          label-position="top"
          @submit.native.prevent
          @keyup.enter.native="submitForm('changePasswordForm')"
        >
          <el-form-item :label="$t('changePassword.password')" prop="password">
            <el-input
              :type="showPass.password ? 'text' : 'password'"
              v-model="changePasswordForm.password"
              autocomplete="off"
            >
              <img
                :src="showPass.password ? showIcon : hiddenIcon"
                slot="suffix"
                alt=""
                class="mtb-15 mlr-10 icon-pass"
                @click="showPass.password = !showPass.password"
              />
            </el-input>
          </el-form-item>

          <el-form-item
            :label="$t('changePassword.passwordNew')"
            prop="passwordNew"
          >
            <el-input
              :type="showPass.new ? 'text' : 'password'"
              v-model="changePasswordForm.passwordNew"
              autocomplete="off"
              ><img
                :src="showPass.new ? showIcon : hiddenIcon"
                slot="suffix"
                alt=""
                class="mtb-15 mlr-10 icon-pass"
                @click="showPass.new = !showPass.new"
            /></el-input>
          </el-form-item>

          <el-form-item
            :label="$t('changePassword.confirmPassword')"
            prop="confirmPassword"
          >
            <el-input
              :type="showPass.check ? 'text' : 'password'"
              v-model="changePasswordForm.confirmPassword"
              autocomplete="off"
              ><img
                :src="showPass.check ? showIcon : hiddenIcon"
                slot="suffix"
                alt=""
                class="mtb-15 mlr-10 icon-pass"
                @click="showPass.check = !showPass.check"
            /></el-input>
          </el-form-item>

          <el-form-item class="button-group change-pass">
            <el-button
              type="primary"
              class="button-login"
              :disabled="isLoadingAuth"
              @click="submitForm('changePasswordForm')"
            >
              {{ $t('changePassword.submitButton') }}
            </el-button>
            <p @click="backtoEmployeePage" class="backToEmployee">
              {{ $t('common.backToEmployee') }}
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import * as pageRouter from '@/constants/pageRouter';
import { handleError, redirectRouter } from '@/helper';
import {
  require,
  sizePassword,
  password,
  spacePassword,
  checkFullWidth,
} from '@/helper/validate';
import hiddenIcon from '@/assets/images/hide-pass.svg';
import showIcon from '@/assets/images/show-pass.svg';

export default {
  data() {
    const validateNewPass = (rule, value, callback) => {
      require(rule, value, callback);
      sizePassword(rule, value, callback);
      spacePassword(rule, value, callback);
      checkFullWidth(rule, value, callback);

      return callback();
    };

    const validateConfirmPass = (rule, value, callback) => {
      require(rule, value, callback);
      sizePassword(rule, value, callback);
      spacePassword(rule, value, callback);
      checkFullWidth(rule, value, callback);

      if (value !== this.changePasswordForm.passwordNew) {
        return callback(new Error(this.$t('validate.dontMatch')));
      }

      return callback();
    };

    return {
      changePasswordForm: {
        password: '',
        passwordNew: '',
        confirmPassword: '',
      },
      showPass: {
        password: false,
        new: false,
        check: false,
      },
      showIcon,
      hiddenIcon,
      validator: {
        password: [{ validator: password, trigger: 'blur' }],
        passwordNew: [{ validator: validateNewPass, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPass, trigger: 'blur' }],
      },
    };
  },

  computed: mapGetters('auth', ['isLoadingAuth']),
  methods: {
    ...mapActions('auth', ['changePassword']),
    submitForm(changePasswordForm) {
      this.$refs[changePasswordForm].validate(
        (valid) =>
          valid &&
          this.changePassword({
            passwordOld: this.changePasswordForm.password,
            passwordNew: this.changePasswordForm.passwordNew,
          })
      );
    },

    backtoEmployeePage() {
      redirectRouter(pageRouter.EMPLOYEE);
    },
  },
  watch: {
    error: (error) => handleError(error),
    'changePasswordForm.password'() {
      this.$refs['changePasswordForm'].clearValidate('password');
    },
    'changePasswordForm.passwordNew'() {
      this.$refs['changePasswordForm'].clearValidate('passwordNew');
    },
    'changePasswordForm.confirmPassword'() {
      this.$refs['changePasswordForm'].clearValidate('confirmPassword');
    },
  },
};
</script>

<style lang="scss">
@import '../Login/styles.module.scss';
@import './styles.module.scss';
</style>
